import React, { useState } from "react";
import Notiflix from "notiflix";
import { FaLockOpen } from "react-icons/fa";
import { Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import PostApiCall from "./Helpers/PostAPI";
export default function ChangePassword({ isOpen, handdleToggleModal }) {
	const [newPassword, SetNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const navigate = useNavigate();

	const onChangePassword = () => {
		Notiflix.Loading.Circle('');
		var login = localStorage.getItem('CustomerData');
		var details = JSON.parse(login)
		PostApiCall.postRequest({
			userid: details[0].fld_customerid,
			password: confirmPassword,
			salt: details[0].fld_salt,
		}, "ChangeCustomerPassword").then((results) =>
			results.json().then(obj => {
				if (results.status == 200 || results.status == 201) {
					Notiflix.Loading.Remove()
					Notiflix.Notify.Success('Password Successfully updated')
					handdleToggleModal();
					navigate('/')
				}
				else {
					Notiflix.Loading.Remove()
					Notiflix.Notify.Failure('something went wrong, try again later')
				}
			}
			)
		)
	}

	const handleChangePassword = () => {
		if (newPassword === "") {
			Notiflix.Notify.Failure('New Password can not be empty')
			return;
		} else if (confirmPassword === "") {
			Notiflix.Notify.Failure('Confirm Password can not be empty')
			return;
		} else if (newPassword !== confirmPassword) {
			Notiflix.Notify.Failure("New Password and Confirm New Password does not match")
			return;
		} onChangePassword();
	}


	return (
		<>


			<Modal show={isOpen} onHide={handdleToggleModal} centered>
				<Modal.Header closeButton className="pb-0 border-0">
				</Modal.Header>
				<Modal.Body>
					<div className="change-pass-icon mb-4 text-center">
						<FaLockOpen size={50} />
						<h2>Change Password</h2>
					</div>
					<Form>
						<Form.Group controlId="newPassword" className="mb-3">
							<Form.Control
								type="password"
								placeholder="New Password"
								value={newPassword}
								onChange={(e) => SetNewPassword(e.target.value)}
							/>
						</Form.Group>
						<Form.Group controlId="confirmPassword">
							<Form.Control
								type="password"
								placeholder="Confirm Password"
								value={confirmPassword}
								onChange={(e) => setConfirmPassword(e.target.value)}
							/>
						</Form.Group>
					</Form>
					<div className="mt-3">
						<Button
							variant="danger"
							size="lg"
							className="w-100 mb-3 "
							onClick={handleChangePassword}>
							Change Password
						</Button>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
}
